export const CHAT_CONTEXT = {
    CHAT: 'chat',
    WORKFLOW: 'workflow',
};
